export default class ToTheTop {
    constructor(options = {}) {
      const defaults = {
        buttonId: 'btnTop',
        scrollOffset: 20,
        smoothScroll: true,
      };
      this.settings = { ...defaults, ...options };
  
      this.button = document.getElementById(this.settings.buttonId);
  
      this.handleScroll = this.handleScroll.bind(this);
      this.scrollToTop = this.scrollToTop.bind(this);
    }
    
    init() {
      if (!this.button) {
        console.warn(`ToTheTop: No element found with ID '${this.settings.buttonId}'`);
        return;
      }
  
      this.button.style.display = 'none';
      window.addEventListener('scroll', this.handleScroll);
      this.button.addEventListener('click', this.scrollToTop);
    }
  
    handleScroll() {
      const { scrollOffset } = this.settings;
      const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
  
      if (scrollTop > scrollOffset) {
        this.button.style.display = 'block';
      } else {
        this.button.style.display = 'none';
      }
    }

    scrollToTop() {
      if (this.settings.smoothScroll && 'scrollBehavior' in document.documentElement.style) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      } else {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      }
    }
  }
  